/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vast_Vast_Elk_LookInputs */

const en_vast_vast_elk_look = /** @type {(inputs: Vast_Vast_Elk_LookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export failed`)
};

const de_vast_vast_elk_look = /** @type {(inputs: Vast_Vast_Elk_LookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export fehlgeschlagen`)
};

/**
* | output |
* | --- |
* | "Export failed" |
*
* @param {Vast_Vast_Elk_LookInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const vast_vast_elk_look = /** @type {((inputs?: Vast_Vast_Elk_LookInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vast_Vast_Elk_LookInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vast_vast_elk_look(inputs)
	return de_vast_vast_elk_look(inputs)
});